<template>
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" :title="Title" :is-sub-page="true"></Header>
    <div ref="contentRef" class="container">
      <cube-scroll>
        <div class="result">{{forecastMsg[0]}}</div>
        <SpaceHolder spaceheight="0"></SpaceHolder>
        <div class="result">{{forecastMsg[1]}}</div>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import SpaceHolder from '../../components/SpaceHolder'
import { queryForecast } from '@/api/test'

export default {
  name: 'ForecastResult',
  components: {
    Header,
    SpaceHolder
  },
  data () {
    return {
      backgroundUrl: '',
      forecastMsg: []
    }
  },
  mounted () {
    document.title = this.$route.query.title

    this.getData()
  },
  computed: {
    Title () {
      return this.$store.state.common.forecastResult
    }
  },
  methods: {
    getData () {
      var content = this.$route.query.content
      queryForecast({
        // diagramsContent: this.$store.state.common.forecastContent
        diagramsContent: content
      }).then((res) => {
        this.forecastMsg.splice(0)
        res.data.contents.forEach((item, idx) => {
          this.forecastMsg.push(item)
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%

.container
  width 100%
  box-sizing border-box
  padding 10px 15px 24px 15px
  .result
    box-sizing border-box
    padding 17px 16px
    background #fff
    color #545454
    font-size 15px
    font-weight 400
    line-height 21px
    text-align start
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
